<template>
  <div id="ViewFiles" dir="rtl">
    <net-pa-list-page-card
      title="فرم‌ها و فایل‌های جانبی"
      description="از این بخش می‌توانید فرم‌ها و فایل‌های مورد نیاز خود را دریافت کنید"
      :show-back="true"
    >
      <files-list></files-list>
    </net-pa-list-page-card>
  </div>
</template>
<script>
import NetPaListPageCard from "../../Tools/NetPa/NetPaListPageCard.vue";
import FilesList from "./FilesList.vue";

export default {
  components: {
    NetPaListPageCard,
    FilesList,
  },
};
</script>
